import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    PEOPLE_REQUEST,
    PEOPLE_REQUEST_SUCCESS,
    PEOPLE_REQUEST_FAILURE,
    PEOPLE_FILTER,
    PEOPLE_EDIT,
    PEOPLE_ADD,
    PEOPLE_CANCEL,
    PEOPLE_UPSERT_REQUEST,
    PEOPLE_UPSERT_REQUEST_SUCCESS,
    PEOPLE_UPSERT_REQUEST_FAILURE
} from "../actions/people.actions";

const initialState = {
    people: [],
    filteredPeople: [],
    person: { id: -1 },
    categories: [],
    isLoading: true,
    search: "",
    category: 0,
    showDisabled: false,
    showInternal: true,
    showExternal: false,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setPeople(state, people, categories) {
    let newState = update(state, {
        people: { $set: people },
        categories: { $set: categories }
    });
    return newState;
}

function setFilter(state, search, category, showDisabled, showInternal, showExternal) {
    let newState = update(state, {
        search: { $set: search },
        category: { $set: category },
        showDisabled: { $set: showDisabled },
        showInternal: { $set: showInternal },
        showExternal: { $set: showExternal }
    });
    return newState;
}

function setFilteredPeople(state) {
    let people = [...state.people];
    if (!state.showDisabled) {
        people = people.filter(f => f.enabled);
    }
    if (!state.showInternal) {
        people = people.filter(f => f.peopleType != 2);
    }
    if (!state.showExternal) {
        people = people.filter(f => f.peopleType != 1);
    }
    if (state.search !== "") {
        people = people.filter(f => {
            if (f.title) {
                if (f.title.toLowerCase().indexOf(state.search.toLowerCase()) != -1) {
                    return true;
                }
            }
            return false;
        });
    }
    if (state.category != 0) {
        people = people.filter(f => {
            if (f.peopleCategories) {
                var categories = f.peopleCategories.filter(c => c.enabled && c.categoryId == state.category);
                if (categories.length > 0) {
                    f.sortOrder = categories[0].sortOrder;
                    return true;
                }
            }
            return false;
        });
        people = [...people.sort((a, b) => a.sortOrder - b.sortOrder)];
    }
    let newState = update(state, {
        filteredPeople: { $set: people }
    });
    return newState;
}

function setPerson(state, person) {
    if (person.id != -1) {
        if (person.id == 0) {
            person = new CreDtos.People();
            person.id = 0;
            person.peopleCategories = [];
            person.enabled = true;
            person.peopleType = 2;
        } else {
            if (!person.peopleCategories) {
                person.peopleCategories = [];
            }
        }
        // prepare for edit by added any required empty categories
        if (state.categories) {
            state.categories.forEach(c => {
                if (person.peopleCategories.filter(f => f.categoryId == c.id).length == 0) {
                    let peopleCategory = new CreDtos.PeopleCategory();
                    peopleCategory.id = 0;
                    peopleCategory.categoryName = c.categoryName;
                    peopleCategory.enabled = false;
                    peopleCategory.sortOrder = 0;
                    peopleCategory.categoryId = c.id;
                    person.peopleCategories.push(peopleCategory);
                }
            });
        }
        person.peopleCategories.sort((a, b) => a.categoryId - b.categoryId);
    }
    let newState = update(state, {
        person: { $set: person }
    });
    return newState;
}

export default function people(state = initialState, action) {
    switch (action.type) {
        case PEOPLE_REQUEST:
            return loading(state, true);
        case PEOPLE_REQUEST_SUCCESS:
            return setFilteredPeople(setPeople(loading(state, false), action.people, action.categories));
        case PEOPLE_REQUEST_FAILURE:
            return loading(state, false);
        case PEOPLE_FILTER:
            return setFilteredPeople(setFilter(state, action.search, action.category, action.showDisabled, action.showInternal, action.showExternal));
        case PEOPLE_EDIT:
            return setPerson(state, action.person);
        case PEOPLE_ADD:
            return setPerson(state, { id: 0 });
        case PEOPLE_CANCEL:
            return setPerson(state, { id: -1 });
        case PEOPLE_UPSERT_REQUEST:
            return saving(state, true);
        case PEOPLE_UPSERT_REQUEST_SUCCESS:
            return saving(setPerson(state, { id: -1 }), false);
        case PEOPLE_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/people.ts